import classNames from 'classnames';

type Props = {
    class?: string;
    className?: string;
};
export function Spacer({ class: _class, className, ...props }: Props) {
    return <div {...props} className={classNames(_class, className, 'grow')} />;
}
